import {useTranslation} from "react-i18next"
import {useStProjectsContext} from "../../reactContext/contextCustomHooks/useStProjectsContext"
import {useEcpProjectsContext} from "../../reactContext/contextCustomHooks/useEcpProjectsContext"

export default function ProjectsTabs({type}) {
    const {t} = useTranslation()
    const {stProjectsContext, setStProjectsAction} = useStProjectsContext()
    const {ecpProjectsContext, setEcpProjectsAction} = useEcpProjectsContext()

    const handleClick = (tab) => {
        type === "st" ? setStProjectsAction({type: "ST_PROJECTS_SET_TAB", payload: {tab: tab}}) : setEcpProjectsAction({type: "ECP_PROJECTS_SET_TAB", payload: {tab: tab}})
    }

    return (
        <>
        <div className="SECTION PROJECTS-TABS">
            <p title={type === "st" ? t("My subtitling projects") : t("My ECP projects")} className={`tab ${(type === "st" ? stProjectsContext.tab : ecpProjectsContext.tab) === "my-projects" && "active"}`} onClick={() => handleClick("my-projects")}>{type === "st" ? t("My ST projects") : t("My ECP projects")}</p>
            <p title={t("Shared projects")} className={`tab ${(type === "st" ? stProjectsContext.tab : ecpProjectsContext.tab) === "shared-projects" && "active"}`} onClick={() => handleClick("shared-projects")}>{t("Shared projects")}</p>
            <p title={t("Recycle bin")} className={`tab ${(type === "st" ? stProjectsContext.tab : ecpProjectsContext.tab) === "recycle-bin" && "active"}`} onClick={() => handleClick("recycle-bin")}>{t("Recycle bin")}</p>
        </div>
        </>
    )
}